import "./app/public-path";
// =========================
// Polyfill's
// =========================
import "custom-event-polyfill";

// =========================
// Framework's
// =========================

import Vue from "vue";
import Vuex from "vuex";
import { mount } from "./mount";

Vue.prototype.$mount = mount;
window.Vue = Vue;
window.Vuex = Vuex;

import script2 from "./app/plugins/script2";
Vue.use(script2);

import "./app/jQuery";

import "bootstrap";

// =========================
// COMPONENTS
// =========================
// =========================
// Basket
// =========================
Vue.component("quantity-input", () => import("./app/components/item/QuantityInput.vue"));
Vue.component("basket-preview", () => import("./app/components/basket/BasketPreview.vue"));
Vue.component("basket-totals", () => import("./app/components/basket/BasketTotals.vue"));
Vue.component("basket-list", () => import("./app/components/basket/list/BasketList.vue"));
Vue.component("coupon", () => import("./app/components/basket/Coupon.vue"));


// =========================
// Common
// =========================
import LazyLoad from "./app/components/common/LazyLoad.vue";

Vue.component("lazy-load", LazyLoad);
// Images

import LazySingleImg from "./app/components/common/LazySingleImg.vue";

Vue.component("lazy-single-img", LazySingleImg);

import LazyImg from "./app/components/common/LazyImg.vue";
Vue.component("lazy-img", LazyImg);

Vue.component("lazy-picture", () => import("./app/components/common/LazyPicture.vue"));
import Icon from "./app/components/pageDesign/Icon.vue";

Vue.component("icon", Icon);

import MobileNavigation from "./app/components/pageDesign/MobileNavigation.vue";

Vue.component("mobile-navigation", MobileNavigation);
import Notifications from "./app/components/pageDesign/Notifications.vue";

Vue.component("notifications", Notifications);

Vue.component("loading-animation", () => import("./app/components/pageDesign/LoadingAnimation.vue"));

// =========================
// User
// =========================
// legacy non-shopbuilder component
import UserLoginHandler from "./app/components/customer/login/UserLoginHandler.vue";
Vue.component("user-login-handler", UserLoginHandler);
import ReCaptcha from "./app/components/customer/ReCaptcha.vue";
Vue.component("recaptcha", ReCaptcha);
// =========================
// ItemList
// =========================
import ItemLazyImg from "./app/components/itemList/ItemLazyImg.vue";
Vue.component("item-lazy-img", ItemLazyImg);

// =========================
// Search and Filter
// =========================
import ItemSearch from "./app/components/itemList/ItemSearch.vue";
Vue.component("item-search", ItemSearch);
Vue.component("search-suggestion-item", () => import("./app/components/itemList/SearchSuggestionItem.vue"));
// Todo: Remove Feuerwerk Startseite
Vue.component("item-filter-list", () => import("./app/components/itemList/filter/ItemFilterList.vue"));

// =========================
// Newsletter
// =========================
// Todo: Remove Feuerwerk Startseite
Vue.component("newsletter-unsubscribe-input", () => import("./app/components/newsletter/NewsletterUnsubscribeInput.vue"));
Vue.component("my-newsletter-form", () => import("./app/components/newsletter/MyNewsletterForm.vue"));

// =========================
// Cookie
// =========================
import CookieConsent from "./app/components/pageDesign/CookieConsent.vue";
Vue.component("cookie-consent", CookieConsent);

// =========================
// External
// =========================
import LazyHydrate from "vue-lazy-hydration";
Vue.component("lazy-hydrate", LazyHydrate);
import ClientOnly from "./app/components/common/ClientOnly.vue";
Vue.component("client-only", ClientOnly);

import NotificationMessage from "./app/components/pageDesign/NotificationMessage.vue";
Vue.component("notification-message", NotificationMessage);

// =========================
// DIRECTIVES
// =========================
import "./app/directives/basket/basketItemQuantity";
import "./app/directives/basket/basketItemSum";
import "./app/directives/basket/toggleBasketPreview";
import "./app/directives/common/truncateTooltip";
import "./app/directives/customer/logout";
import "./app/directives/helper/populateStore";
import "./app/directives/helper/validate";
import "./app/directives/helper/waitingAnimationInfinite";
import "./app/directives/navigation/navigationTouchHandler";
import "./app/directives/navigation/openMobileNavigation";
import "./app/directives/pageDesign/scrollToTop";
import "./app/directives/pageDesign/tooltip";


// =========================
// FILTERS
// =========================
// import "./app/filters/ageRestriction.filter";
import "./app/filters/currency.filter";
import "./app/filters/date.filter";
import "./app/filters/fileName.filter";
// import "./app/filters/fileUploadPath.filter";
import "./app/filters/graduatedPrice.filter";
import "./app/filters/hasItemDefaultPrice.filter";
import "./app/filters/inputUnit.filter";
// import "./app/filters/itemBundleName.filter";
import "./app/filters/itemCrossPrice.filter";
import "./app/filters/itemImage.filter";
import "./app/filters/itemImageAlternativeText.filter";
import "./app/filters/itemImages.filter";
import "./app/filters/itemName.filter";
import "./app/filters/itemPrice.filter";
import "./app/filters/itemUrl.filter";
import "./app/filters/numberFormat.filter";
import "./app/filters/propertySurcharge.filter";
import "./app/filters/propertyFileUrl.filter";
import "./app/filters/translate.filter";
import "./app/filters/truncate.filter";


// =========================
// MIXINS
// =========================
import "./app/mixins/template.mixin";
import "./app/mixins/getJsonData.mixin";


// =========================
// Bootstrap frameworks
// =========================
import "./app/main";

import TranslationService from "./app/services/TranslationService";
import { createStore, initClientListeners, initClientStore, initServerStore } from "./app/store";
import { initListener } from "./app/services/ApiService";

window.ceresTranslate = TranslationService.translate;

Vue.prototype.$translate = TranslationService.translate;
Vue.prototype.$ceres = App;

const store = createStore();

window.ceresStore = store;

initServerStore(store);
initClientStore(store);
initClientListeners(store);
initListener();
